import styled from "styled-components";
import { typography } from "@streeteasy/design-system";

export const Title = styled(typography.H2)`
  margin-bottom: 8px;
`;

export const SubTitle = styled(typography.P)``;
